import { isEmpty } from 'lodash';

import { callApi } from '../../../../apiCaller';
import {
     API_SYSTEM_ADMIN_CLOSE_SOW_ORDER,
     API_SYSTEM_ADMIN_SOW_ORDER_INFO,
     API_SYSTEM_ADMIN_SOW_ORDER,
     API_SYSTEM_ADMIN_SOW_ORDER_DETAIL,
     API_SYSTEM_ADMIN_ADD_ITEMS_TO_SOW,
     DEFAULT_FN,
} from '../../../../constants';
import { toastError } from '../../../../utils';
import { setIsWaiting } from '../../../../actions/general';
import { toast } from 'react-toastify';

export const ADD_ADMIN_SOW_ORDERS = 'addAdminSowOrders';
export const ADD_ADMIN_SOW_ORDER_DETAIL = 'addAdminOrderDetail';
export const UPDATE_ADMIN_SOW_ORDER_DETAIL = 'updateAdminOrderDetail';

export const addAdminSowOrders = (sowOrders) => {
     return {
          type: ADD_ADMIN_SOW_ORDERS,
          payload: sowOrders,
     };
};
export const addAdminSowOrderDetail = (sowOrder) => {
     return {
          type: ADD_ADMIN_SOW_ORDER_DETAIL,
          payload: sowOrder,
     };
};

export const updateAdminSowOrderDetail = (sowOrder) => {
     return {
          type: UPDATE_ADMIN_SOW_ORDER_DETAIL,
          payload: sowOrder,
     };
};

export const fetchAdminSowOrdersRequest = (nextDispatch) => (dispatch) => {
     const { setIsLoadingFilter, paginationPayload } = nextDispatch;

     const { page, pageSize, filter, sortBy, sortType } = paginationPayload;

     const { searchFilterColumns } = filter;

     const checkSearchFilterColumns = isEmpty(searchFilterColumns);

     const queryFilter = !checkSearchFilterColumns ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     setIsLoadingFilter(true);

     callApi(`${API_SYSTEM_ADMIN_SOW_ORDER}?page=${page}&pageSize=${pageSize}${queryFilter}&sortBy=${sortBy}&sortType=${sortType}`, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const { rows, count } = response.data;

               const newOrder = {
                    rows: rows.map((order) => {
                         return {
                              ...order,
                              organizationName: order.organization?.name ?? '',
                         };
                    }),
                    count,
               };

               dispatch(addAdminSowOrders(newOrder));
          })
          .finally(() => setIsLoadingFilter(false));
};

export const fetchAdminSowOrderDetailRequest = (orderId) => async (dispatch) => {
     return await callApi(API_SYSTEM_ADMIN_SOW_ORDER_DETAIL.replace(':id', orderId), 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const sowOrder = response.data;
          const arrangedOrderItems = [];

          sowOrder.orderItems.forEach((orderItem) => {
               if (!orderItem.tierId) {
                    arrangedOrderItems.push(orderItem);
                    return;
               }

               const tierIndex = arrangedOrderItems.findIndex((tierItem) => tierItem.tierId === orderItem.tierId);
               if (tierIndex !== -1) {
                    arrangedOrderItems[tierIndex] = {
                         ...arrangedOrderItems[tierIndex],
                         quantity: arrangedOrderItems[tierIndex].quantity + 1,
                    };
               } else {
                    arrangedOrderItems.push(orderItem);
               }
          });
          sowOrder.orderItems = arrangedOrderItems;

          dispatch(addAdminSowOrderDetail(sowOrder));
     });
};

export const updateAdminSowOrderDetailRequest = (nextDispatch) => (dispatch) => {
     const { sowOrderId, values, handleCancel } = nextDispatch;
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_SOW_ORDER_DETAIL.replace(':id', sowOrderId), 'PUT', values)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const sowOrder = response.data;
               const arrangedOrderItems = [];

               sowOrder.orderItems.forEach((orderItem) => {
                    if (!orderItem.tierId) {
                         arrangedOrderItems.push(orderItem);
                         return;
                    }

                    const tierIndex = arrangedOrderItems.findIndex((tierItem) => tierItem.tierId === orderItem.tierId);
                    if (tierIndex !== -1) {
                         arrangedOrderItems[tierIndex] = {
                              ...arrangedOrderItems[tierIndex],
                              quantity: arrangedOrderItems[tierIndex].quantity + 1,
                         };
                    } else {
                         arrangedOrderItems.push(orderItem);
                    }
               });
               sowOrder.orderItems = arrangedOrderItems;

               dispatch(addAdminSowOrderDetail(sowOrder));

               toast.success('Update successfully');
          })
          .finally(() => {
               handleCancel();

               dispatch(setIsWaiting(false));
          });
};

export const closeSowOrderRequest = (orderId, setShowPopupClose) => (dispatch, getState) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_CLOSE_SOW_ORDER.replace(':id', orderId), 'PUT')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (response.data) {
                    const sowOrder = getState().shared.sowOrderDetail;
                    sowOrder.status = 'Close';
                    setShowPopupClose(false);
                    dispatch(addAdminSowOrderDetail(sowOrder));
               } else {
                    toastError('The order closed fail');
               }

               toast.success('The order closed successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateSowOrderInfoRequest =
     (orderId, payload, setShowPopupClose = DEFAULT_FN) =>
     (dispatch) => {
          dispatch(setIsWaiting(true));
          callApi(API_SYSTEM_ADMIN_SOW_ORDER_INFO.replace(':id', orderId), 'PUT', payload)
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    if (!response.data || !Object.keys(response.data).length) {
                         toast.error('Update SOW Order failed!');
                         return;
                    }

                    const updatePayload = {
                         sowId: payload.sowId,
                         sowName: payload.sowName,
                         sowMemo: payload.sowMemo,
                         sowBDR: payload.sowBDR,
                         sowSignDate: payload.sowSignDate,
                    };
                    const updatedPayload = {};

                    for (const key in updatePayload) {
                         if (Object.prototype.hasOwnProperty.call(updatePayload, key)) {
                              const item = updatePayload[key];
                              if (item) {
                                   updatedPayload[key] = item;
                              }
                         }
                    }

                    setShowPopupClose(false);

                    if (Object.keys(updatedPayload).length) {
                         dispatch(updateAdminSowOrderDetail(updatedPayload));
                    }

                    toast.success('Update SOW Order successfully');
               })
               .finally(() => {
                    dispatch(setIsWaiting(false));
               });
     };

export const addItemsToSOWOrderRequest = (nextDispatch) => (dispatch, getState) => {
     const { sowOrderId, payload, setShowAddItems } = nextDispatch;

     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_ADD_ITEMS_TO_SOW.replace(':sowOrderId', sowOrderId), 'PUT', payload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(fetchAdminSowOrderDetailRequest(sowOrderId));
               setShowAddItems(false);

               toast.success('Update successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};
